export const myInboxImages = {
  refresh_icon: 'assets/img/Refresh_2_light.svg',
  no_split_icon: 'assets/img/no-split.svg',
  right_split_icon: 'assets/img/right-split.svg',
  below_split_icon: 'assets/img/below-split.svg',
  default_density_icon: 'assets/img/default-density.svg',
  comfort_density_icon: 'assets/img/comfortable-density.svg',
  compact_density_icon: 'assets/img/compact-density.svg',
  email_1_icon: 'assets/menu-customisation-icons/Email/email1.svg',
  email_2_icon: 'assets/menu-customisation-icons/Email/email2.svg',
  email_3_icon: 'assets/menu-customisation-icons/Email/email3.svg',
  email_4_icon: 'assets/menu-customisation-icons/Email/email4.svg',
  email_5_icon: 'assets/menu-customisation-icons/Email/email5.svg',
  email_6_icon: 'assets/menu-customisation-icons/Email/email6.svg',
  email_7_icon: 'assets/menu-customisation-icons/Email/email7.svg',
  email_8_icon: 'assets/menu-customisation-icons/Email/email8.svg',
  email_9_icon: 'assets/menu-customisation-icons/Email/email9.svg',
};
